/**
 * Google Analytics Implementation
 * Loads asynchronously to avoid blocking page rendering
 */

const GA_MEASUREMENT_ID = 'G-84YYTMRLKJ';

// Initialize Google Analytics
export const initAnalytics = () => {
  // Skip if not in browser or during pre-rendering
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  // Skip if user agent indicates headless browser (react-snap)
  if (navigator.userAgent.includes('HeadlessChrome') || navigator.webdriver) {
    return;
  }

  // Only load in production or if explicitly enabled
  if (process.env.NODE_ENV !== 'production' && !process.env.REACT_APP_ENABLE_ANALYTICS) {
    return;
  }

  // Load gtag.js asynchronously
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    // Optimize for performance
    send_page_view: true,
    // Reduce data collection for better performance
    anonymize_ip: true,
  });
};

// Track page views for React Router
export const trackPageView = (path) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
